<ml-mdm-vpp-asset-list-ui [assets]="vppAssets()"
                          (selectedAssetChange)="selectedAssetChanged($event)">
</ml-mdm-vpp-asset-list-ui>